import * as React from 'react';
import { connect } from 'react-redux';
import * as ViewManagementModule from 'Modules/ViewManagementModule';
import AccountMenu from 'components/Layout/Header/Composites/AccountMenu';
import Notifications from 'components/Layout/Header/Composites/Notifications';
import {RootState} from "Redux/Reducers/_RootReducer";
import * as UserModule from "Modules/UserModule";
export type Props = {
    showUI:boolean
};
export type State = {};
export type ConnectedProps = {
    viewManagementStore: ViewManagementModule.Types.ViewManagementStore;
    userRole: UserModule.UserEnumTypes.RoleName;
};
class DetailsSidebar extends React.Component<Props & ConnectedProps, State> {
    constructor(props: Props & ConnectedProps) {
        super(props);
    }
    public render() {
        const { detailsSidebarloaderVisible } = this.props.viewManagementStore;
        return (
            <div className="sidebar details-right" data-testid="sidebar-details">
                <div className="details-right__heading">
                    {
                        this.props.showUI &&
                        <>
                            {this.props.userRole !== UserModule.UserEnumTypes.RoleName.EXTERNAL && <Notifications />}
                            <AccountMenu />
                        </>
                    }

                </div>
                {detailsSidebarloaderVisible && (
                    <div className="detailsSidebar__loader loader--sm">
                        <div className="loader__inner loader__inner--sm" />
                    </div>
                )}
                {this.props.children}
            </div>
        );
    }
}
function mapStateToProps(state: RootState): ConnectedProps {
    return {
        viewManagementStore: state.viewManagementStore,
        userRole: state.userStore.user?.roleName
    };
}

export default connect(mapStateToProps)(DetailsSidebar);



// WEBPACK FOOTER //
// ./src/components/Layout/DetailsSidebar/_DetailsSidebar.tsx